import { Directive, ElementRef, Input, ViewChild } from '@angular/core';
import { SharedService } from '../Services/shared.service';

@Directive({
  selector: '[appHasPermission]'
})
export class HasPermissionDirective {
    @Input('appHasPermission') permission: string="";
   constructor(private el: ElementRef, private permissionService: SharedService) { }
   ngOnInit() {
    const hasPermission : any= this.permissionService.hasPermission(this.permission);  
    if (hasPermission == undefined || hasPermission == false) {
         this.el.nativeElement.style.display = 'none';
       }
      else{
         this.el.nativeElement.style.display = 'block';
      }
  }
}